



















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {DebtEmployee} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPaymentTypeLabel from "../../../../../ladings/List/components/PaymentTypeLabel.vue";

const columns = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: 80
  },
  {
    title: "Mã vận đơn",
    dataIndex: "billLading.ladingCode",
    key: "ladingCode",
  },
  {
    title: "Thu tiền người nhận",
    dataIndex: "billLading.receiverCollect",
    key: "receiverCollect",
    scopedSlots: {customRender: 'receiverCollect'},
  },
  {
    title: "Tổng thu",
    dataIndex: "money",
    key: "money",
    scopedSlots: {customRender: 'money'},
  },
];
@Component({
  name: "ReceiptDebtPartnerTable",
  components: {LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
  @Prop() readonly debtPartners!: Array<DebtEmployee>;
  @PropSync('debtIds', { default: () => [], type: Array }) syncDebtIds!: number[];
  columns = columns;

  onSelectedIdsChange(selectedIds: any) {
    this.syncDebtIds = selectedIds;
  }
}
